<div mat-dialog-content>
  <ng-container *ngIf="KEYS(skuInfoMapping) as skus">
    <mat-tab-group *ngIf="skus.length > 1" animationDuration="0ms" (selectedTabChange)="skuChanged($event)">
      <mat-tab *ngFor="let sku of skus" [label]="sku">
        <ng-template matTabContent>
          <ng-container [ngTemplateOutlet]="selectNumber"></ng-container>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <ng-container *ngIf="skus.length === 1" [ngTemplateOutlet]="selectNumber"></ng-container>
  </ng-container>
</div>

<ng-template #selectNumber>
  <mat-progress-bar *ngIf="loading" mode="indeterminate" class="mb-2.5"></mat-progress-bar>
  <div class="mb-4 number__wrapper">
    <h3>
      <span class="title" [style.fontWeight]="500">Selected numbers</span>
      <span class="text-[#0000008a] mr-4">
        ({{ skuInfoMapping[selectedSku]?.selectedNumbers.length }}/{{ skuInfoMapping[selectedSku]?.total }})</span
      >
      <button *ngIf="skuInfoMapping[selectedSku]?.selectedNumbers.length" mat-button (click)="removeAll()" color="warn">
        Remove all
      </button>
    </h3>
    <div
      *ngIf="skuInfoMapping[selectedSku]?.selectedNumbers.length"
      class="numbers__list flex flex-wrap"
      [style.height.px]="100"
      [style.maxHeight.px]="100"
    >
      <div
        *ngFor="let number of skuInfoMapping[selectedSku]?.selectedNumbers"
        (click)="toggleNumber(number)"
        class="number active p-4 py-2 font-medium border rounded m-2 cursor-pointer"
      >
        {{ number.number }}
      </div>
    </div>
    <div
      *ngIf="!skuInfoMapping[selectedSku]?.selectedNumbers.length"
      class="p-4 text-center"
      [style.height.px]="100"
      [style.maxHeight.px]="100"
    >
      No numbers selected
    </div>
  </div>

  <div *ngIf="numbers$ | async as numbers">
    <h3>
      <span class="title" [style.fontWeight]="500">Available numbers</span>
      <span class="text-[#0000008a]"> (Showing {{ numbers.length }}/{{ totalAvailableNumber1 }})</span>
    </h3>
    <div>
      <mat-form-field>
        <mat-label>Search...</mat-label>
        <input matInput [formControl]="searchNumberCtrl" placeholder="Enter number to search" />
      </mat-form-field>
    </div>
    <div class="numbers__list flex flex-wrap">
      <ng-container *ngIf="numbers.length">
        <div
          *ngFor="let number of numbers"
          (click)="toggleNumber(number)"
          [class.active]="number['active']"
          class="number p-4 py-2 font-medium border rounded m-2 cursor-pointer"
        >
          {{ number.number }}
        </div>
      </ng-container>
      <ng-container *ngIf="!numbers.length">
        <div class="text-center no-number p-4">No numbers found</div>
      </ng-container>
    </div>
  </div>
</ng-template>
